/* eslint-disable react-hooks/exhaustive-deps */

import { useState } from 'react'

import { useBreakpointValue } from 'native-base'

import { UseRVCalculatorsSim2026 } from './RVCalculatorsSim2026.types'

export const useRVCalculatorsSim2026: UseRVCalculatorsSim2026 = ({
  userIsGR,
  handleOpenCalculator,
  calculatorIsOpen,
  calculatorOnClose,
  dontShowConfirm,
  handleDontShowConfirm,
  confirmIsOpen,
  confirmOnClose,
  confirmOnOpen,
  handleCloseCalculator
}) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  const [currentTab, setCurrentTab] = useState<number>(0)

  return {
    isMobile,
    handleOpenCalculator,
    calculatorIsOpen,
    calculatorOnClose,
    dontShowConfirm,
    handleDontShowConfirm,
    confirmIsOpen,
    confirmOnClose,
    confirmOnOpen,
    handleCloseCalculator,
    currentTab,
    setCurrentTab,
    userIsGR
  }
}
